/**
 *  @flow
 */

import React from 'react';
import gql from 'graphql-tag';
import styled from 'styled-components';
import { format } from 'date-fns';
import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';
import { Icon, Grid } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { Modal, Button } from '../../../../components';
import DateRangeFrom from '../../containers/schedule/DateRangeFrom';
import DateRangeTo from '../../containers/schedule/DateRangeTo';

const StyledModal = styled(Modal)`
    width: 480px !important;
`;

export const GENERATE_SCHEDULE_QUERY = gql`
    mutation generateSchedule($input: GenerateScheduleInput!) {
        generateSchedule(input: $input) {
            salonId
            masterId
        }
    }
`;

const GenerateInvoiceDialog = ({ trigger, open, onClose, master }) => {
    const salon = useSelector(({ user }) => user.get('salon'));
    const firstRangeFrom = useSelector(({ schedule }) =>
        schedule.get('firstRangeFrom'),
    );
    const firstRangeTo = useSelector(({ schedule }) =>
        schedule.get('firstRangeTo'),
    );
    const secondRangeFrom = useSelector(({ schedule }) =>
        schedule.get('secondRangeFrom'),
    );
    const secondRangeTo = useSelector(({ schedule }) =>
        schedule.get('secondRangeTo'),
    );

    const [generateSchedule] = useMutation(GENERATE_SCHEDULE_QUERY);

    const onGenerate = () => {
        const masterId = (master && master.id) || null;
        return generateSchedule({
            variables: {
                input: {
                    salonId: salon,
                    masterId,
                    firstRangeFrom: format(new Date(firstRangeFrom), 'yyyy-MM-dd HH:mm'),
                    firstRangeTo: format(new Date(firstRangeTo), 'yyyy-MM-dd HH:mm'),
                    secondRangeFrom: format(new Date(secondRangeFrom), 'yyyy-MM-dd'),
                    secondRangeTo: format(new Date(secondRangeTo), 'yyyy-MM-dd'),
                },
            },
        }).then(() => {
            onClose();
        });
    };

    return (
        <StyledModal trigger={trigger} open={open} onClose={onClose}>
            <Modal.Header>
                <FormattedMessage
                    id="pages.settings.schedule.scheduleGenerate.title"
                    defaultMessage="Generate schedule"
                />
            </Modal.Header>
            <Modal.Content>
                <Grid>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <FormattedMessage
                                id="pages.settings.schedule.scheduleGenerate.fromRange"
                                defaultMessage="From range:"
                            />
                            <br />
                            <br />
                            <DateRangeFrom allowAllDates />
                        </Grid.Column>
                        <Grid.Column>
                            <FormattedMessage
                                id="pages.settings.schedule.scheduleGenerate.toRange"
                                defaultMessage="To range:"
                            />
                            <br />
                            <br />
                            <DateRangeTo allowAllDates />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onGenerate} primary>
                    <Icon name="checkmark" />
                    <FormattedMessage
                        id="pages.settings.schedule.scheduleGenerate.generate"
                        defaultMessage="Generate"
                    />
                </Button>
                <Button onClick={onClose} basic>
                    <Icon name="remove" />
                    <FormattedMessage
                        id="pages.settings.schedule.scheduleGenerate.cancel"
                        defaultMessage="Cancel"
                    />
                </Button>
            </Modal.Actions>
        </StyledModal>
    );
};

export default GenerateInvoiceDialog;
